'use strict'

import { axiosPost } from '../axios/axios.js'
import { EventBus } from '../EventBus/EventBus.js'

let publicSigningKey = null

export async function initNotifications (callback) {
  if ('serviceWorker' in navigator) {
    await registerServiceWorker()
    const registration = await navigator.serviceWorker.ready
    const subscription = await registration.pushManager.getSubscription()

    navigator.serviceWorker.addEventListener('message', event => {
      console.log(event.data)
      if (event && event.data && event.data.msg === 'update-request') {
        console.log('event')
        EventBus.$emit('update-request', {})
      }
    })

    if (!subscription) {
      await getPublicSigningKey()
      if (publicSigningKey.byteLength !== 0) {
        await subscribe()
        await sendSubcribe(callback)
      }
    } else {
      await sendSubcribe(callback)
    }
  }
}

async function getPublicSigningKey () {
  await fetch('/service/delta/push/getPublicSigningKey')
    .then(response => response.arrayBuffer())
    .then(key => {
      publicSigningKey = key
    })
    .finally(() => console.info('Application Server Public Key fetched from the server'))
}

async function registerServiceWorker () {
  await navigator.serviceWorker.register('/sw.js', { scope: './' })
    .then((reg) => {
      console.log('Registration succeeded')
    }).catch((error) => {
      console.log('Registration failed with: ' + error)
    })

  await navigator.serviceWorker.ready
}

async function subscribe () {
  const registration = await navigator.serviceWorker.ready
  await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: publicSigningKey
  })
  console.log('subscribed success')
}

async function sendSubcribe (callback) {
  const registration = await navigator.serviceWorker.ready
  const subscription = await registration.pushManager.getSubscription()
  console.log(subscription)

  const bodyFormData = new FormData()
  await bodyFormData.set('properties', JSON.stringify(subscription))
  await axiosPost({
    url: '/service/delta/push/subscribe',
    data: bodyFormData,
    onSuccess: (response) => {
      console.log('subscribed info send to server')
      callback()
    },
    onFailure: (errMsg) => {
      console.log('error: subscribed info send to server')
    }
  })
}
